import { createBrowserHistory, createMemoryHistory } from 'history';

const history = process.env.NODE_ENV !== 'test' ? createBrowserHistory() : createMemoryHistory();

history.goBack = history.back;

export default history;